import React from 'react';
import { formatNumber } from 'devextreme/localization';
import './PerformanceCell.scss';
const getGridCellData = (gridData) => gridData.data[gridData.column.caption.toLowerCase()];
export const PerformanceCell = (cellData) => {

  const gridCellData = cellData;
  return gridCellData.data.performance != null ? (
    <div className={gridCellData.data.performance >= 0.00 ? 'inc' : 'dec'}>
      {gridCellData.data.squads} <div className="perfomance">{formatNumber(gridCellData.data.performance, { type: 'percent', precision: 2 })}</div>
    </div>
  ) : null;
};
export const PerformanceCellOnlyIncrease = (cellData) => {

  const gridCellData = cellData;
  return gridCellData.data.performance != null ? (
    <div className={gridCellData.data.performance >= 0.00 ? 'inc' : ''}>
      <div className="perfomance">{formatNumber(gridCellData.data.performance, { type: 'percent', precision: 2 })}</div> {gridCellData.data.squads}
    </div>
  ) : null;
};
